import axios from "axios";
import { YoutubeCommentPreset } from "./youtubeCommentPreset";

export async function saveYoutubeAllocationComment(
  uid: number,
  partyid: number,
  preset: YoutubeCommentPreset,
) {
  const response = await axios.post("/api/comment", {
    uid,
    partyid,
    category: preset.tag,
    comment: preset.content,
    iscomp: 2,
  });
  if (response.status !== 201) {
    throw new Error("코멘트 저장에 실패했습니다.");
  }
}
